module.exports = __webpack_public_path__ + "static/media/video-still-min.9085713e.png";